import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumb } from '@/components/Breadcrumb/Breadcrumb';
import { EstimaLandingBlock } from '@/components/EstimaLandingBlock/EstimaLandingBlock';
import { FsboBlock } from '@/components/FsboBlock/FsboBlock';
import { PlaceLinkBlock } from '@/components/PlaceLinkBlock/PlaceLinkBlock';
import { PriceBlock } from '@/components/PriceBlock/PriceBlock';
import { SidePanelLayout } from '@/components/SidePanelLayout/SidePanelLayout';
import { usePageLayoutContext } from '@/hooks/usePageLayoutContext/usePageLayoutContext';
const MicroNeighborhoodPage = () => {
    const { pricePageProps: { pricePageContext, breadcrumbData }, } = usePageLayoutContext();
    const placeLinkBoxes = undefined;
    return (_jsxs(_Fragment, { children: [_jsx("span", { translate: "no", children: _jsx(Breadcrumb, { breadcrumbData: breadcrumbData }) }), _jsx(SidePanelLayout, { priceBlock: _jsx(PriceBlock, { pricePageContext: pricePageContext }), fsboBlock: _jsx(FsboBlock, {}), estimaLandingBlock: _jsx(EstimaLandingBlock, { pricePageContext: pricePageContext }), 
                /*priceEvolutionChart={
                        <PriceEvolutionChart
                            pricePageContext={pricePageContext}
                            indices={indices!}
                        />
                    }*/
                linkBoxesBlock: _jsx(PlaceLinkBlock, { place: pricePageContext.place, placeLinkBoxes: placeLinkBoxes }) })] }));
};
export default MicroNeighborhoodPage;
